/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type {
  ReactElement,
} from 'react';
import styled from 'styled-components';

import type {
  OptionProps,
} from 'react-select';

import { Checkbox } from '../../Checkbox';

import type {
  OptionTypeBase,
} from '../types';

const Wrapper = styled.div<{
  $isFocused: boolean;
}>(({
  $isFocused,

  theme: {
    colors,
    fonts,
    indents,
  },
}) => ({
  ...fonts.DEFAULT,
  fontSize: 'inherit',
  display: 'block',
  userSelect: 'none',
  WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
  paddingTop: 4,
  paddingBottom: 4,
  paddingLeft: indents.INDENT_2,
  paddingRight: indents.INDENT_2,
  backgroundColor: $isFocused ? colors.ACTION_BACKGROUND : 'transparent',
  color: colors.NEUTRAL_DEFAULT,
  cursor: 'pointer',
}));

const CheckboxWrapper = styled.div({
  pointerEvents: 'none',
});

export function Option<
OptionType extends OptionTypeBase,
IsMulti extends boolean,
>({
  children,
  innerRef,
  innerProps,
  isFocused,
  isSelected,
  className,

  selectProps: {
    isMulti,
  },
}: OptionProps<OptionType, IsMulti>): ReactElement {
  return (
    <Wrapper
      ref={innerRef as any}
      className={className}
      $isFocused={isFocused}
      {...innerProps}
    >
      {
        isMulti ? (
          <CheckboxWrapper>
            <Checkbox
              checked={isSelected}
              label={children}
            />
          </CheckboxWrapper>
        ) : children
      }
    </Wrapper>
  );
}
